<!--
create by melody on 2018/11/4
description:报表查询页面
-->
<template>
	<div>
		<a id="target" style="display: none" :href="exportUrl"></a>
		<page-header :title="title"></page-header>
		<div class="search-container hdp-uf hdp-uf-vc hdp-uf-dc" style="padding:50px 0;">
			<div class="hdp-uf hdp-w-60">
				<el-form ref="form" :model="form" :rules="rules" class="hdp-w-100" label-width="150px">
					<el-form-item :label="$t('m.reportName')" prop="reportName" class="hdp-w-60">
						<el-select filterable v-model="reportName" @change="getParamList()">
							<el-option v-for="(item, index) in reportNameList" :key="index" :label="item.label" :value="item.value" ></el-option>
						</el-select>
					</el-form-item>
					<el-form-item key="1" v-if="paramList.includes('ouName')" :label="$t('m.ouName')" prop="ouName" class="hdp-w-60">
						<el-select filterable v-model="form.ouName" clearable>
							<el-option v-for="(item, index) in busEntityList" :key="index" :label="item" :value="item" ></el-option>
						</el-select>
					</el-form-item>
                    <el-form-item key="1" v-if="paramList.includes('contract_currency')" :label="$t('m.contract_currency')" prop="contract_currency" class="hdp-w-60">
                        <el-select filterable v-model="form.contract_currency" clearable>
                            <el-option v-for="(item, index) in currencyList" :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
					<el-form-item key="2" v-if="paramList.includes('periodName')" :label="$t('m.periodName')" prop="periodName" class="hdp-w-60">
						<el-date-picker
							style="width:100%;"
					      	v-model="form.periodName"
					      	type="month"
					      	value-format="yyyy-MM"
					        :placeholder="$t('m.chooseDate')">
					    </el-date-picker>
					</el-form-item>
					<el-form-item key="3" v-if="paramList.includes('leaseItemNumber')" :label="$t('m.leaseItemNumber')" prop="leaseItemNumber"  class="hdp-w-60">
						<el-input v-model="form.leaseItemNumber" clearable></el-input>
					</el-form-item>
					<el-form-item key="4" v-if="paramList.includes('transactionType')" :label="$t('m.transactionType')" prop="transactionType"  class="hdp-w-60">
						<el-select filterable v-model="form.transactionType" clearable>
							<el-option v-for="(item, index) in transactionList2" :key="index" :label="item.label" :value="item.value" ></el-option>
						</el-select>
					</el-form-item>
					<el-form-item key="5" v-if="paramList.includes('vendorName')" :label="$t('m.vendorName')" prop="vendorName" class="hdp-w-60">
						<el-input v-model="form.vendorName" clearable></el-input>
					</el-form-item>
					<el-form-item key="6" v-if="paramList.includes('startPeriodName')" :label="$t('m.startPeriodName')" prop="startPeriodName"  class="hdp-w-60">
						<el-date-picker
	                        style="width:100%;"
	                        v-model="form.startPeriodName"
	                        :picker-options="pickerOptions0"
	                        type="month"
	                        value-format="yyyy-MM"
	                        :placeholder="$t('m.chooseDate')">
	                    </el-date-picker>
					</el-form-item>
					<el-form-item key="7" v-if="paramList.includes('endPeriodName')" :label="$t('m.endPeriodName')" prop="endPeriodName" class="hdp-w-60">
						<el-date-picker
	                        style="width:100%;"
	                        v-model="form.endPeriodName"
	                        :picker-options="pickerOptions1"
	                        type="month"
	                        value-format="yyyy-MM"
	                        :placeholder="$t('m.chooseDate')">
	                    </el-date-picker>
					</el-form-item>
					<el-form-item key="8" v-if="paramList.includes('primaryLedger')" :label="$t('m.primaryLedger')" prop="primaryLedger" class="hdp-w-60">
						<el-select filterable v-model="form.primaryLedger" clearable>
							<el-option v-for="(item, index) in accountList" :key="index" :label="item.label" :value="item.value" ></el-option>
						</el-select>
					</el-form-item>
					<el-form-item key="9" v-if="paramList.includes('leaseItemType')" :label="$t('m.leaseItemType')" prop="leaseItemType" class="hdp-w-60">
						<el-select filterable v-model="form.leaseItemType" clearable>
							<el-option v-for="(item, index) in leaseItemTypeList" :key="index" :label="item.label" :value="item.value" ></el-option>
						</el-select>
					</el-form-item>
					<el-form-item key="10" v-if="paramList.includes('journalScene')" :label="$t('m.documentType')" prop="journalScene" class="hdp-w-60">
						<el-select filterable v-model="form.journalScene" clearable>
							<el-option v-for="(item, index) in journalSceneList" :key="index" :label="item.label" :value="item.value" ></el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label="" class="hdp-w-60">
                        <el-button class="file-btn" type="primary" icon="el-icon-circle-check-outline" v-bind:disabled="reportName?false:true" @click="checkParam()" v-loading.fullscreen.lock="fullscreenLoading"> {{$t('m.submit')}} </el-button>
                    </el-form-item>
				</el-form>
			</div>
		</div>
        <el-dialog
            :title="$t('m.chooseExpNum')"
            v-if="dialogVisible"
            :visible.sync="dialogVisible"
            width="30%">
            <div class="dialog-content">
                <el-radio-group v-model="currentPage" style="width: 90%">
                    <el-row :gutter="20">
                        <el-col :span="6" style="margin: 10px 0 " v-for="item in pageArr" :key="item"><el-radio :label="item">第{{item}}个{{pageSize}}条</el-radio></el-col>
                    </el-row>
                </el-radio-group>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{$t('m.cancel')}}</el-button>
                <el-button type="primary" @click="exportPage()"  v-loading.fullscreen.lock="fullscreenLoading">{{$t('m.sure')}}</el-button>
            </span>
        </el-dialog>
	</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
	data () {
		return {
			title: {
				firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.OPERATE_MANAGE'),
                thirdTitle: this.$t('m.REPORT_QUERY')
			},
			//开始日期：当前日期后和结束日期后不可勾选
            pickerOptions0: {
                disabledDate: (time) => {
                    if (this.form.endPeriodName) {
                        var d = new Date(this.form.endPeriodName);
                        return time.getTime() > d.getTime() - 86400000
                    }
                },
            },
            //结束日期：当前日期后和开始日期前不可勾选
            pickerOptions1: {
                disabledDate: (time) => {
                    if (this.form.startPeriodName) {
                        var d = new Date(this.form.startPeriodName);
                        return time.getTime() < d.getTime()
                    }
                }
            },
			reportName: '',
			form: {
				ouName: '',
				periodName: '',
				leaseItemNumber:'',
				transactionType:'',
				vendorName:'',
				startPeriodName: '',
				endPeriodName: '',
				primaryLedger: '',
				leaseItemType: '',
				journalScene: '',
                contract_currency: ''
			},
			rules: {},
			reportNameList: [],
			paramList: [],
			busEntityList: [],
            transactionList: [],
            transactionList2: [],
			accountList: [],
			leaseItemTypeList: [],
			journalSceneList: [],
			exportUrl: '',
            onClick: true,
            fullscreenLoading: false,
            dialogVisible: false,
            pageSize: 1000,
            currentPage: 1,
		}
	},
	methods: {
		getParamList() {
			this.$refs['form'].resetFields()
			this.$refs['form'].clearValidate()
			this.$commonFunc.commonRequest('get', '/report/getTableParam', 'getReportParamByCode', {tableCode: this.reportName})
            .then(res=>{
            	if(res.obj) {
            		let paramListTem = JSON.parse(res.obj).params
            		let rulesList = {}
            		this.paramList = []
            		paramListTem.forEach((o,i)=>{
            			for (var key in o) {
            				this.paramList.push(key)
            				this.form[key] = ''
            				if(o[key]) {
            					rulesList[key] = [
            						{ required: true, message: this.$t('m.input'), trigger: 'change' }
            					]
            				} else {
            					rulesList[key] = [
            						{ required: false, message: this.$t('m.input'), trigger: 'change' }
            					]
            				}
            			}
            		})
            		this.rules = rulesList
            	} else {
            		this.rules = {}
            		this.paramList = []
            	}
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
		},
		checkParam() {
			this.$refs['form'].validate((valid) => {
				if (valid) {
                    this.fullscreenLoading = true
                    this.currentPage = 1
					this.$commonFunc.commonRequest('get', '/report/validData', 'reportValidData', {tableCode: this.reportName, param: JSON.stringify(this.form)})
			            .then(res=>{
			            	if(res.obj) {
                                let total = Number(res.obj)
                                this.pageArr = []
                                this.pages = Math.ceil(total / this.pageSize)
                                for(let i = 1 ; i <= this.pages; i++) {
                                    this.pageArr.push(i)
                                }
			            	    console.log('report name: %s',JSON.stringify(this.reportName))
                                // if(this.reportName == '139' || this.reportName == '141' || this.reportName == '143' ||this.reportName == '144' )
                                {
                                    this.dialogVisible = false
                                    this.fullscreenLoading = false
                                    this.exportPage()
                                }
			            	   // else
                               //  {
                               //      this.dialogVisible = true;
                               //  }

			            	} 
                            this.fullscreenLoading = false
			            })
			            .catch(res=>{
			                this.$message.error(res.message)
                            this.fullscreenLoading = false
			            })
				} else {
					return false;
				}
			})
		},
        exportPage() {

		    // if(this.onClick)
            // {
            //     this.onClick = false;
                this.exportUrl = (localStorage.getItem('apiServerHost') ? 'http://'+localStorage.getItem('apiServerHost') : this.$config.APISERVER.host)
                    + '/report/export?tableCode=' + this.reportName
                    + '&param=' + encodeURIComponent(JSON.stringify(this.form))
                    + '&lap-cookie-token=' + this.$store.state.userInfo.userInfoObj.token
                    + '&pageSize=' + this.pageSize
                    + '&pageNum=' + this.currentPage
                    + '&t=' + Date.now()
                this.dialogVisible = false

                window.location.href= this.exportUrl;
                return ;
                // this.$requestService.downloadFile(this.exportUrl)
                //     .then(res=>{
                //         this.fullscreenLoading = true
                //         //
                //         setTimeout(()=>{
                //              // document.getElementById("target").click()
                //         }, 1000)
                //         setTimeout(()=>{
                //             this.fullscreenLoading = false
                //             // this.onClick = true;
                //         }, 2000)
                //     })
                //     .catch(res=>{
                //         this.$message.error(res.message)
                //     })
          //  }

        },
        getAccountList() {
            this.$commonFunc.commonRequest('get', '/config/dataPermission/getUserDatePermissionList')
            .then(res=>{
                if(res.obj && res.obj.length) {
                    res.obj.forEach((o,i)=>{
                        this.accountList.push({label: o.primaryLedgerName, value: o.primaryLedgerName})
                    })
                } 
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        getBusEntity() {
            this.$commonFunc.commonRequest('get', '/config/primaryData/getUserCompanyInfo')
            .then(res=>{
                if(res.obj && res.obj.length) {
                    this.busEntityList = res.obj   
                }
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //根据value匹配数组霹匹配list
        getListByValues(values, arr) {
            let matchArr = []
            values.forEach((o,i) => {
                arr.forEach((o2, i2) => {
                    if(o2.value == o) {
                        matchArr.push(o2)
                    }
                })
            })
            return matchArr
        },
	},
	async mounted() {
		// this.busEntityList = await this.$commonFunc.getValueSetList(this.$valueSetObj.BUSINESS_ENTITY)
		this.reportNameList = await this.$commonFunc.getDataDicList(this.$dataDicObj.REPORT_NAME, true)
		this.transactionList = await this.$commonFunc.getValueSetList(this.$valueSetObj.TRANSACTION_TYPE, true)
        //除豁免的所有
        this.transactionList2 = this.getListByValues(['SLP', 'RVS', 'RET', 'PAT', 'INSERT', 'REV'], this.transactionList)
		this.leaseItemTypeList = await this.$commonFunc.getValueSetList(this.$valueSetObj.LEASE_ITEM_TYPE)
		this.journalSceneList = await this.$commonFunc.getValueSetList(this.$valueSetObj[this.$t('m.documentTypeValueset')], true)
        this.getAccountList()
        this.getBusEntity()
        this.currencyList = await this.$commonFunc.getValueSetList(this.$valueSetObj.CURRENCY)
	}
}
</script>
<style scoped>
.search-container {
	background: #ffffff;
}
.table-container {
	padding: 24px;
	margin: 32px 0;
	background: #ffffff;
}
.block {
	text-align: right;
}
.el-form-item .el-form-item__content {
	margin-left: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/operate/ReportQuery.vue